import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-register-activation',
  templateUrl: './register-activation.component.html',
  styleUrls: ['./register-activation.component.css']
})
export class RegisterActivationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
